import { getSharedStyleSheet } from './sharedStyleSheet.js';

class TaggableTextarea extends HTMLElement {
    static observedAttributes = ['disabled'];

    constructor() {
        super();
    }

    attributeChangedCallback(attrName, oldValue, newValue) {
        this.dynamicRender();
    }

    connectedCallback() {
        if (!this.shadowRoot) {
            this.attachShadow({mode: "open"});

            // Make sure element obeys parent sizing
            this.shadowRoot.host.style.display = 'block';

            // Share a single parsed stylesheet across all shadow roots
            getSharedStyleSheet().then(sheet => {
                this.shadowRoot.adoptedStyleSheets = [sheet];
            });

            this._wrapper = document.createElement('div');
            this._wrapper.classList.add('taggable-textarea-wrapper');
            this._wrapper.classList.add('editable-content');
            this._wrapper.tabIndex = 0;
            this._wrapper.contentEditable = 'true';
            this.shadowRoot.appendChild(this._wrapper);

            this._wrapper.innerHTML = this.getAttribute('value') ?? '';

            this._wrapper.addEventListener('keyup', e => {
                // TODO: Trigger change event
//            this.shadowRoot.dispatchEvent(e);

                const triggerChars = (this.getAttribute('trigger-characters') ?? '').split('')

                triggerChars.forEach((c) => {
                    if (c === e.key) {
                        // Trigger 'trigger' event
                        this.shadowRoot.dispatchEvent(new CustomEvent('trigger', {
                            composed: true,
                            bubbles: true,
                            detail: {
                                key: e.key
                            }
                        }));
                    }
                });
            });

            // Placeholder support
            if (this.getAttribute('placeholder') && !this.getAttribute('value')) {
                // Add dummy text node
                const textNode = document.createTextNode('');
                this._wrapper.appendChild(textNode);

                this._placeholder = document.createElement('div');
                this._placeholder.className = 'placeholder';
                this._placeholder.contentEditable = false;
                this._placeholder.style.display = 'none';
                this._wrapper.appendChild(this._placeholder);

                this._placeholder.style.display = 'block';
                this._placeholder.innerText = this.getAttribute('placeholder')
            }

            this.addEventListener('focus', e => {
                const placeholder = this._wrapper.querySelector('.placeholder');
                if (placeholder) placeholder.remove();
                this._wrapper.focus();
            });
        }

        this.dynamicRender();
    }

    dynamicRender() {
        if ('undefined' === typeof this._wrapper) return;

        if (!!this.getAttribute('disabled')) {
            this._wrapper.contentEditable = false;
            this._wrapper.classList.add('disabled');
        } else {
            this._wrapper.contentEditable = true;
            this._wrapper.classList.remove('disabled');
        }
    }

    get value() {
        if (this._wrapper.querySelector('.placeholder')) {
            return '';
        } else if (this._wrapper.innerHTML.trim() === '<br>') {
            return '';
        } else {
            return this._wrapper.innerHTML;
        }
    }

    set value(text) {
        return this._wrapper.innerHTML = text;
    }
}

customElements.define('taggable-textarea', TaggableTextarea);
export default TaggableTextarea;